<script setup lang="ts">
const solutions = [
  'Pantau detail perubahan saldo aktif untuk menjaga arus kas tetap teratur.',
  'Ketahui estimasi dana yang akan diterima dari paket COD yang masih dalam proses pengiriman.',
  'Cek riwayat penyesuaian ongkir untuk mengetahui kelebihan dan kekurangan ongkir yang mempengaruhi saldo aktif.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-4 lg:py-16">
    <UiSectionWrapper
      title="Laporan Keuangan yang Transparan"
      description="Akses laporan saldo masuk dan keluar, termasuk pencairan saldo hingga penyesuaian ongkir yang transparan dan terperinci."
      hero-image="/images/batch-2/report-add-2.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(solution, index) in solutions"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ solution }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
